import { render, staticRenderFns } from "./LogisticsUserSelect.vue?vue&type=template&id=677d0e56"
import script from "./LogisticsUserSelect.vue?vue&type=script&lang=js"
export * from "./LogisticsUserSelect.vue?vue&type=script&lang=js"
import style0 from "./LogisticsUserSelect.vue?vue&type=style&index=0&id=677d0e56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports